export default __webpack_public_path__ + "static/media/logo_beta_mobile.05e3e170.png";